import type { UseQueryResult } from '@tanstack/react-query';
import { useGetCustomerWishLists } from './useGetCustomerWishLists';

export const useIsAddedToWishList = (
    productId: string,
): Omit<UseQueryResult<boolean>, 'refetch'> => {
    const { data, ...rest } = useGetCustomerWishLists();

    return {
        ...rest,
        data:
            data?.some((list) =>
                list.customerProductListItems?.some((pli) => pli.productId === productId),
            ) ?? false,
    };
};
